import { render, staticRenderFns } from "./LuuTruForm.vue?vue&type=template&id=d538d0c4"
import script from "./LuuTruForm.vue?vue&type=script&lang=js"
export * from "./LuuTruForm.vue?vue&type=script&lang=js"
import style0 from "./LuuTruForm.vue?vue&type=style&index=0&id=d538d0c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports